module.exports = __webpack_public_path__ + "img/nav-design-sets@2x.5fcf491.webp";